import { render, staticRenderFns } from "./AddCardsDialog.vue?vue&type=template&id=05389a7c&scoped=true"
import script from "./AddCardsDialog.vue?vue&type=script&lang=js"
export * from "./AddCardsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05389a7c",
  null
  
)

export default component.exports